import { Component, Inject, Input, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { PauseType } from 'src/app/app-models/realTimeModels';
import { realTimeService } from 'src/app/services/services/realtime.service';
@Component({
    selector: 'app-set-pause-dialog',
    templateUrl: './set-pause-dialog.component.html',
    styleUrls: ['./set-pause-dialog.component.scss'],
    standalone: false
})

export class SetPauseDialogComponent implements OnInit {
    pauseReasons: PauseType[] = [];
    selectedPauseId: number | null = null;
    constructor(
        public dialogRef: MatDialogRef<SetPauseDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public dialogData: any,
        private realTimeService: realTimeService
    ) { }

    ngOnInit() {
        this.realTimeService.getPauseTypes().subscribe((pauseTypes) => {
            this.pauseReasons = pauseTypes ?? [];
                if (this.pauseReasons.length === 0) {
                                this.pauseReasons = [
                    {
                        id: -1,
                        description: 'Pause'
                    } as PauseType
                ];

                this.selectedPauseId = -1;
                return;
            }
            const selectedDescription = this.dialogData?.pauseDescription;
            const matchingPause = selectedDescription
                ? this.pauseReasons.find((pause) => pause.description === selectedDescription)
                : null;
            this.selectedPauseId = matchingPause?.id ?? this.pauseReasons[0].id;
        });
    }

    closeDialog(): void {
        this.dialogRef.close();
    }

    closeDialogWithResult(result?: any): void {
        this.dialogRef.close(result);
    }
}
